export const LINE_OPTIONS = [
  { label: 'Evolution', id: 'Evolution' },
  { label: 'Executive', id: 'Executive' },
  { label: 'Professional', id: 'Professional' }
];


// WEBPACK FOOTER //
// ./src/enums/line.js